import cx from 'classnames';
import { getRequestUser, AppState } from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import styles from './ContentUnlockOverlay.mscss';

interface OwnProps {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;

    enabled: boolean;
    source: string;
    header: string;
    description: string;
    ctaButtons: React.ReactNode;
}

interface StateProps {
    requestUser: UserEntity | null;
}

type Props = OwnProps & StateProps;

const ContentUnlockOverlayComponent: React.FC<Props> = ({
    children,
    className,
    enabled,
    style,
    source,
    header,
    description,
    ctaButtons,
}) => {
    const scriptContainerRef = useRef<HTMLDivElement>(null);

    // Append/remove script on enabled toggle
    useEffect(() => {
        const scriptClassName = 'nuload-script';

        // @ts-ignore
        if (enabled && !window.__nuloadAlreadyInjected) {
            const existing = document.head.querySelector(`.${scriptClassName}`);
            if (!existing) {
                const scriptTag = document.createElement('script');
                scriptTag.setAttribute('async', 'true');
                scriptTag.setAttribute('class', scriptClassName);
                scriptTag.type = 'module';
                scriptTag.src = 'https://www.nuload.net/modrykonik_sk/ad.js';
                document.head.appendChild(scriptTag);
                // @ts-ignore
                window.__nuloadAlreadyInjected = true;
            }
        }

        return () => {
            const existing = document.head.querySelector(`.${scriptClassName}`);
            if (existing) {
                document.head.removeChild(existing);
            }
        };
    }, [enabled]);

    if (!enabled) {
        return <>{children}</>;
    }

    return (
        <div
            className={cx(
                styles.ContentUnlockOverlay,
                enabled && styles.ContentUnlockOverlay__enabled,
                className,
            )}
            style={style}
        >
            <div className={styles.ContentUnlockOverlay__originalLayer}>
                {children}
            </div>
            <div
                className={styles.ContentUnlockOverlay__overlayWithPlaceholder}
                id={`content-overlay-${source}`}
            >
                <div
                  className={styles.ContentUnlockOverlay__overlayLayer}
                  role="dialog"
                  aria-modal="true"
                  ref={scriptContainerRef}
                >
                    <div className={styles.ContentUnlockOverlay__overlayLayer__blurred}>
                        {children}
                    </div>
                    <div className={styles.ContentUnlockOverlay__overlayLayer__visiblePart}>
                        {children}
                    </div>
                    <div className={styles.ContentUnlockOverlay__overlayLayer__overlayMask} />
                    <div className={styles.ContentUnlockOverlay__overlayLayer__dialog}>
                        <div className={styles.ContentUnlockOverlay__overlayLayer__dialog__header}>
                            {header}
                        </div>
                        <div className={styles.ContentUnlockOverlay__overlayLayer__dialog__text}>
                            {description}
                        </div>
                        <div className={styles.ContentUnlockOverlay__ctaButtons}>
                            {ctaButtons}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: AppState): StateProps => ({
    requestUser: getRequestUser(state),
});

export const ContentUnlockOverlay = connect(mapStateToProps)(ContentUnlockOverlayComponent);
